<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="products">
      @for (product of products.controls; track product; let index = $index) {
        @if (index == 0) {
          <ng-container [formGroup]="product">
            <ng-container formGroupName="parameters">
              <div class="row">
                <div class="col-md-12">
                  <pr-input-radio
                    formControlName="isAlreadyGfvAssociate"
                    columns="3"
                    [toggle]="true"
                    [isDefault]="false"
                    label="Êtes vous déjà associé(e) d’un GFV de Bacchus Conseil ?"
                  >
                  </pr-input-radio>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <pr-input-radio
                    formControlName="isAlreadyGfvAssociationMember"
                    columns="3"
                    [toggle]="true"
                    [isDefault]="false"
                    label="Êtes vous déjà membre de l’association « Les Disciples de Bacchus » ? "
                  >
                  </pr-input-radio>
                </div>
              </div>
            </ng-container>
          </ng-container>
        }
      }
    </ng-container>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
